import * as React from "react"
import type { SVGProps } from "react"
const SvgBookmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12 18.57-4.2 1.8q-1 .43-1.9-.16-.9-.6-.9-1.66V5.57q0-.82.59-1.41A2 2 0 0 1 7 3.57h10q.83 0 1.41.59.6.59.59 1.41v12.97q0 1.08-.9 1.67t-1.9.16zm0-2.2 5 2.15V5.57H7v12.95z" />
  </svg>
)
export default SvgBookmark
